import { render, staticRenderFns } from "./topic-analysis.vue?vue&type=template&id=60b5aef0&scoped=true"
import script from "./topic-analysis.vue?vue&type=script&lang=js"
export * from "./topic-analysis.vue?vue&type=script&lang=js"
import style0 from "./topic-analysis.vue?vue&type=style&index=0&id=60b5aef0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5aef0",
  null
  
)

export default component.exports